<template>
    <div class="row">
        <div class="col-2 text-center"><i class="fas fa-bed"></i></div>
        <div class="col-10 trip-details__rooms-room">
            <div class="row">
                <div class="col-11">
                    {{room.roomTypeName}}
                    <div v-if="hasAdults || hasChildren" class="trip-details__rooms-room-pax">
                        (<span v-if="hasAdults" class="trip-details__rooms-room-adults"><i class="fa fa-male"></i>x{{numberOfAdults}}</span>&nbsp;<span v-if="hasChildren" class="trip-details__rooms-room-children"><i class="fa fa-child"></i>x{{numberOfChildren}}</span>)
                    </div>
                    <div v-show="expanded" v-if="room.adults">
                        <div class="row" v-for="(adult, index) in room.adults" v-bind:key="adult.reference">
                            <div class="col-4">Adult {{index + 1}}:</div>
                            <div class="col-6">
                                <guest-name v-bind:guest="adult"></guest-name>
                            </div>
                        </div>
                        <div class="row" v-for="(child, index) in room.children1" v-bind:key="child.reference">
                            <div class="col-4">Child {{index + 1}}:</div>
                            <div class="col-6">
                                <guest-name v-bind:guest="child"></guest-name>
                            </div>
                        </div>
                        <div class="row" v-for="(child, index) in room.children2" v-bind:key="child.reference">
                            <div class="col-4">Child {{numberOfChildren2 + index + 1}}:</div>
                            <div class="col-6">
                                <guest-name v-bind:guest="child"></guest-name>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-1 trip-details__rooms-room-actions">
                    <i class="fa fa-chevron-down" v-show="!expanded" v-on:click.stop="toggleExpanded"></i>
                    <i class="fa fa-chevron-up" v-show="expanded" v-on:click.stop="toggleExpanded"></i>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import GuestName from '../GuestName'

    export default {
        name: 'TripDetailsRoom',
        components: {GuestName},
        props: {
            room: Object
        },
        data: function () {
            return {
                expanded: false
            }
        },
        computed: {
            hasAdults: function () {
                return this.room.adults && this.room.adults.length > 0
            },
            hasChildren: function () {
                return (this.room.children1 && this.room.children1.length > 0) ||
                    (this.room.children2 && this.room.children2.length > 0)
            },
            numberOfAdults: function () {
                if (this.hasAdults) {
                    return this.room.adults.length
                }
                return 0
            },
            numberOfChildren1: function () {
                if (this.hasChildren) {
                    if (this.room.children1 !== undefined) {
                        return this.room.children1.length
                    }
                }
                return 0;
            },
            numberOfChildren2: function () {
                if (this.hasChildren) {
                    if (this.room.children2 !== undefined) {
                        return this.room.children2.length
                    }
                }
                return 0;
            },
            numberOfChildren: function () {
                return this.numberOfChildren1 + this.numberOfChildren2;
            }
        },
        methods: {
            toggleExpanded: function () {
                this.expanded = !this.expanded
            }
        },
        mounted() {
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/components/modal";
    @import "../../styles/components/task";
    @import "../../styles/components/trip_details";
</style>